// Devices
export const DESKTOP = 'desktop';
export const PHONE = 'phone';
export const TABLET = 'tablet';
export const MOBILE = 'mobile';

// Paths
export const STATIC_IMAGE = '/static/images';
export const IMAGE_PLACEHOLDER = '/static/images/image-placeholder.png';
export const API_PROXY_PATH = '/api';

// Environments
export const ENV_DEVELOPMENT = 'development';
export const ENV_PRODUCTION = 'production';

// Key Codes
export const KEY_ESCAPE = 27;
export const KEY_ENTER = 13;
export const KEY_TAB = 9;
export const KEY_SPACE = 32;
export const KEY_UP_CODE = 38;
export const KEY_LEFT_CODE = 37;
export const KEY_RIGHT_CODE = 39;
export const KEY_DOWN_CODE = 40;
export const API_ERROR_HANDLER_PAGE = '/error';

// HTTP Status
export const STATUS_ERROR = 'ERROR';
export const STATUS_SUCCESS = 'SUCCESS';
export const RESPONSE_OK = 200;
export const RESPONSE_SERVER_ERROR = 500;

// API Method
export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const PATCH = 'PATCH';
export const DELETE = 'DELETE';
export const HEAD = 'HEAD';

// PO Validation Constants
// eslint-disable-next-line no-useless-escape
export const PO_FILENAME_REGX = /[*/?!<>"|\\:]/gm;
export const PO_FILE_SIZE = '32';

export const TOTAL_CART_ITEM_LOWER_LIMIT = 98;
export const EMAIL_INPUT_MAX_LENGTH = 80;
export const RECIPIENT_EMAIL_MAX_LENGTH = 500;
export const RECIPIENT_MAX_EMAIL_ACCEPT = 10;
export const WHITESPACE_REGEX = /^\S*$/;
export const CART_ITEM_COUNT_DESKTOP = 7;
export const CART_ITEM_COUNT_MOBILE = 3;
export const SHARE_CONFIRMATION_MAX_EMAIL_ACCEPT = 5;
